import { render, staticRenderFns } from "./Samples.vue?vue&type=template&id=0750f1ea&scoped=true"
import script from "./Samples.vue?vue&type=script&lang=js"
export * from "./Samples.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/inbox.css?vue&type=style&index=0&id=0750f1ea&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0750f1ea",
  null
  
)

export default component.exports